/* ─────────────────────────────────────────────────────────────────────────
   Referencia USD en el storefront (cobro real = DOP).
   - Lee la tasa EN VIVO desde app_settings de Supabase (misma que usan el ADM
     y el catálogo A Medida) → UN SOLO número unificado en todo el sistema,
     auto-actualizado a diario. La publishable key ya vive en el tema (A Medida)
     y RLS bloquea las columnas de costo, así que no expone nada nuevo.
   - Recalcula "≈ US$X" de cada precio (producto, carrito, cantidad, variante).
   - Si el fetch falla, usa RATE_FALLBACK.
   ───────────────────────────────────────────────────────────────────────── */
(function () {
  var SB_URL = 'https://kyexrnwpybkdemlesfzf.supabase.co';
  var SB_KEY = 'sb_publishable_FI6tR8LxYV-ECuXm9vKIIg_-G4jaEFT';
  var RATE_FALLBACK = 56.93; // respaldo si Supabase no responde
  var RATE = RATE_FALLBACK;

  function apply() {
    var els = document.querySelectorAll('.usd-ref[data-dop-cents]');
    for (var i = 0; i < els.length; i++) {
      var cents = parseFloat(els[i].getAttribute('data-dop-cents'));
      if (!cents || cents <= 0 || !(RATE > 0)) continue;
      var usd = Math.round(cents / 100 / RATE);
      var amt = els[i].querySelector('.usd-ref__amt');
      if (amt && amt.textContent !== String(usd)) amt.textContent = usd;
    }
  }

  var t;
  function scheduleApply() { clearTimeout(t); t = setTimeout(apply, 150); }

  // Lee la tasa en vivo (cachea 1h en sessionStorage para no pegar Supabase en cada página)
  function loadRate() {
    try {
      var cached = sessionStorage.getItem('ppz_usd_rate');
      var cachedAt = parseFloat(sessionStorage.getItem('ppz_usd_rate_at') || '0');
      if (cached && (Date.now() - cachedAt) < 3600000) {
        var rc = parseFloat(cached);
        if (rc > 0) { RATE = rc; return Promise.resolve(); }
      }
    } catch (e) {}
    return fetch(SB_URL + '/rest/v1/app_settings?select=value&key=eq.usd_rate', {
      headers: { apikey: SB_KEY, Authorization: 'Bearer ' + SB_KEY }
    })
      .then(function (r) { return r.json(); })
      .then(function (rows) {
        if (rows && rows[0] && rows[0].value) {
          var v = parseFloat(rows[0].value);
          if (v > 0) {
            RATE = v;
            try {
              sessionStorage.setItem('ppz_usd_rate', String(v));
              sessionStorage.setItem('ppz_usd_rate_at', String(Date.now()));
            } catch (e) {}
          }
        }
      })
      .catch(function () { /* fallback ya está en RATE */ });
  }

  function init() {
    apply(); // primer render con el fallback
    loadRate().then(apply); // recalcula con la tasa en vivo
    if ('MutationObserver' in window) {
      new MutationObserver(scheduleApply).observe(document.body, { childList: true, subtree: true });
    }
    document.addEventListener('variant:update', scheduleApply);
    document.addEventListener('cart:update', scheduleApply);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
